import { render, staticRenderFns } from "./question-pagination.vue?vue&type=template&id=7edc1a53&scoped=true&"
import script from "./question-pagination.vue?vue&type=script&lang=js&"
export * from "./question-pagination.vue?vue&type=script&lang=js&"
import style0 from "./question-pagination.vue?vue&type=style&index=0&id=7edc1a53&prod&lang=css&"
import style1 from "./question-pagination.vue?vue&type=style&index=1&id=7edc1a53&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7edc1a53",
  null
  
)

export default component.exports